import React, { useState, useEffect, lazy } from 'react'
import 'reactflow/dist/style.css'
import ManageWhatsAppBot from '../../components/whatsAppBots/manageBot'
import ConfigPanel from '../../components/whatsAppBots/ConfigPanel'
import { v4 as uuidv4 } from 'uuid'
import { useParams } from 'react-router-dom'

const FlowDiagram = lazy(() => import('../../components/bots/FlowDiagram'))

const WhatsAppBotBuilder: React.FC = () => {
  const [inputJson, setInputJson] = useState<any[]>([])
  const [configJson, setConfigJson] = useState<any>({})
  const [data, setData] = useState<any>({})
  const [activeTabIndex, setActiveTabIndex] = useState(0)
  const tabTitles = ['Manage Bot']
  const params = useParams()
  const appId = params.uuid

  useEffect(() => {
    const fetchBotData = async () => {
      try {
        const token = localStorage.getItem('auth-token')
        if (!token || !appId) return

        const response = await fetch(
          `${process.env.REACT_APP_RESUME_PARSER_URL}/getAllWhatsappApplication?whatsAppIDString=${appId}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${token}`
            }
          }
        )

        if (!response.ok) {
          throw new Error('Failed to fetch WhatsApp bot data')
        }

        const result = await response.json()
        const botData = result || {}

        setInputJson(botData.WhatsAppInput || [])
        setConfigJson(botData)
        setData(botData)
      } catch (error) {
        console.error('Error fetching bot data:', error)
      }
    }

    fetchBotData()
  }, [appId])

  return (
    <section className='row p-4'>
      <div className='col-2 d-flex flex-column card rounded border border-secondary'>
        <ul
          className='nav nav-stretch nav-line-tabs border-transparent flex-nowrap mb-5'
          style={{ margin: 'auto' }}
        >
          {tabTitles.map((title, index) => (
            <li className='nav-item' key={uuidv4()}>
              <button
                className={`nav-link cursor-pointer ${
                  activeTabIndex === index ? 'active fw-bolder' : ''
                }`}
                onClick={() => setActiveTabIndex(index)}
                aria-current={activeTabIndex === index ? 'true' : 'false'}
              >
                {title}
              </button>
            </li>
          ))}
        </ul>

        <ConfigPanel config={configJson} setConfig={setConfigJson} data={data} />
      </div>

      <div className='col border border-secondary mx-3 rounded p-0'>
        {activeTabIndex === 0 && (
          <ManageWhatsAppBot inputJson={inputJson} setInputJson={setInputJson} data={data} />
        )}
      </div>
    </section>
  )
}

export default WhatsAppBotBuilder
